import React from "react";
import { Card, Row, Col, Rate, Button, Tag } from "antd";
import { ShoppingCartOutlined } from "@ant-design/icons";

const coursesData = [
    {
        title: "Développement Web",
        description: "Apprenez les bases du développement web avec HTML, CSS et JavaScript.",
        category: "Technologie",
        rating: 5,
        price: "$50",
        image: "/images/courses/courses4.jpg",
    },
    {
        title: "Data Science",
        description: "Analysez des données et créez des modèles prédictifs.",
        category: "Data",
        rating: 4,
        price: "$60",
        image: "/images/courses/courses3.jpg",
    },
    {
        title: "Intelligence Artificielle",
        description: "Maîtrisez les concepts de l'IA et du Machine Learning.",
        category: "IA",
        rating: 5,
        price: "$80",
        image: "/images/courses/courses1.jpg",
    },
    {
        title: "Marketing Digital",
        description: "Apprenez à booster la visibilité d'une marque en ligne.",
        category: "Business",
        rating: 4,
        price: "$40",
        image: "/images/courses/courses2.jpg",
    },
];

const Courses = () => {
    return (
        <div style={{ padding: "20px" }}>
            <h1 style={{ textAlign: "center", marginBottom: "30px", color: "#004b8d" }}>Liste des Cours</h1>
            <Row gutter={[16, 16]}>
                {coursesData.map((course, index) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={index}>
                        <Card
                            hoverable
                            cover={<img alt={course.title} src={course.image} style={{ height: "200px", objectFit: "cover" }} />}
                            style={{
                                borderRadius: "10px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            <Tag color="blue">{course.category}</Tag>
                            <h3 style={{ color: "#004b8d" }}>{course.title}</h3>
                            <p>{course.description}</p>
                            <div>
                                <Rate disabled defaultValue={course.rating} />
                            </div>
                            <div style={{ marginTop: "10px", fontWeight: "bold", color: "#004b8d" }}>{course.price}</div>
                            <Button
                                type="primary"
                                block
                                style={{ marginTop: "10px", backgroundColor: "#004b8d" }}
                                icon={<ShoppingCartOutlined />}
                            >
                                Acheter ce cours
                            </Button>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default Courses;
